import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import "./modal.scss";
import Button from "../button/button";
const Modal = ({ openModal, isModalOpen, data, children, paymentFunction, paymentButtonLabel}) => {


  const modalContainer = useRef();

  useEffect(() => {
    const handleMouseDown = (e) => {
      if (!modalContainer.current.contains(e.target)) {
        openModal(false);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  });

  // key down events: close modal, change slide

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        openModal(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  console.log("entered-modal")

  return (
    <div className="modalBackground">
      <div className="modalContainer" ref={modalContainer}>
      <div className="buttons_wrapper">
       
         {paymentFunction ? <Button clickAction={paymentFunction}>{paymentButtonLabel}</Button> : ''}
          <div className="closeBtnContainer">
          <AiOutlineClose
            className="closeBtn"
            onClick={() => openModal(false)}
          />
        </div>
      </div>
        
        {children}
        {paymentFunction ? <p ><Button clickAction={paymentFunction}>{paymentButtonLabel}</Button></p>  : ''}
      </div>
    </div>
  );
};

export default Modal;
